import { render, staticRenderFns } from "./admin-bank-page.vue?vue&type=template&id=58a7b4bc"
import script from "./admin-bank-page.vue?vue&type=script&lang=js"
export * from "./admin-bank-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports